import { render, staticRenderFns } from "./selectLawyer.vue?vue&type=template&id=e1036dbc&scoped=true&"
import script from "./selectLawyer.vue?vue&type=script&lang=tsx&"
export * from "./selectLawyer.vue?vue&type=script&lang=tsx&"
import style0 from "./selectLawyer.vue?vue&type=style&index=0&id=e1036dbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1036dbc",
  null
  
)

export default component.exports